(function() {
    'use strict';

a3_cabin_reports.directive('wifiPrograms',wifiPrograms);
 
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name wifiPrograms
   * @restrict EA
   * @description
   *   Implementation of wifiPrograms
   *
   *   Initialize the wifi programs panel needs to have flight in scope
   * @example
   *   Usage:
   *   <wifi-programs></wifi-programs>
   * @ngInject
   */    
function wifiPrograms( ) {
    
    /**
     * Initialize wifiVouchers
     * @memberof wifiVouchers
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link (scope, element, attrs) {
    //   scope.textAndSurfCodes = [];
    //   scope.streamCodes = [];
    }
    return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/WifiVouchers/wifiPrograms.tpl.html',
			scope : false,
            link: link 
    }
}

})();